import { Component, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { environment } from '@env/environment';
import { ViewEncapsulation } from '@angular/core';
import { ImagesService } from '@app/shared/components/images/services/images.service';

@Component({
  selector: 'vc-product-seller-badge',
  templateUrl: './product-seller-badge.component.html',
  styleUrls: ['./product-seller-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class ProductSellerBadgeComponent implements OnChanges {
  @Input()
  seller: any;
  @Input()
  showTooltip = false;

  hasImg = false;
  firstLetter: string;
  public hasSellerRating = environment.feature.seller_rating;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.seller) {
      this.firstLetter = changes.seller.currentValue.firstname.charAt(0);
      if (changes.seller.currentValue.picture) {
        if (changes.seller.currentValue.picture.path !== '' && changes.seller.currentValue.picture.path) {
          this.hasImg = true;
        }
      }
    }
  }

  stopPropagation(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  getImage(path) {
    return ImagesService.buildUrl(path, { w: 88, h: 88, fit: 'crop' });
  }
}
